export const CONTRACTING_TYPE_FIXED = "FIXED";
export const CONTRACTING_TYPE_BID = "BID";

export function normalizeContractingType(raw) {
  const text = String(raw ?? "")
    .trim()
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  if (!text) return "";
  if (
    text === CONTRACTING_TYPE_BID ||
    text.includes("BID") ||
    text.includes("LANCE")
  ) {
    return CONTRACTING_TYPE_BID;
  }
  if (
    text === CONTRACTING_TYPE_FIXED ||
    text.includes("FIXED") ||
    text.includes("FIXO") ||
    text.includes("PRECO")
  ) {
    return CONTRACTING_TYPE_FIXED;
  }
  return "";
}

export function resolveContractingTypeFromFreight(doc = {}) {
  const freight =
    doc?.freight && typeof doc.freight === "object" ? doc.freight : {};
  const bidding =
    (doc?.bidding && typeof doc.bidding === "object" && doc.bidding) ||
    (freight?.bidding && typeof freight.bidding === "object" && freight.bidding) ||
    {};

  const normalized = normalizeContractingType(
    doc?.contractingType ??
      freight?.contractingType ??
      bidding?.contractingType ??
      doc?.contractType ??
      freight?.contractType ??
      doc?.type ??
      freight?.type,
  );

  if (normalized) return normalized;
  if (doc?.type === "bid" || doc?.isBid === true) return CONTRACTING_TYPE_BID;
  return "";
}

export function isBidFreight(freight) {
  return resolveContractingTypeFromFreight(freight) === CONTRACTING_TYPE_BID;
}

export function isValidContractingType(value) {
  const normalized = normalizeContractingType(value);
  return (
    normalized === CONTRACTING_TYPE_FIXED || normalized === CONTRACTING_TYPE_BID
  );
}

export function getContractingBadge(freight) {
  if (isBidFreight(freight)) {
    return {
      label: freight?.contractingLabel || "ABERTO A LANCE",
      variant: "open",
    };
  }
  return {
    label: freight?.contractingLabel || "PREÇO FIXO",
    variant: "fixed",
  };
}

export function getPublishedPriceLabel(freight, { isMasked = false } = {}) {
  if (isBidFreight(freight)) return "Valor de referência";
  if (isMasked) return "Valor Anunciado";
  return "Valor total do frete";
}
